import { __awaiter } from "tslib";
import { addProp } from "@pnp/odata";
import { _Web, Web } from "../webs/types.js";
import { Lists, List } from "./types.js";
import { odataUrlFrom } from "../odata.js";
import { SharePointQueryableCollection } from "../sharepointqueryable.js";
import { escapeQueryStrValue } from "../utils/escapeQueryStrValue.js";
addProp(_Web, "lists", Lists);
addProp(_Web, "siteUserInfoList", List, "siteuserinfolist");
addProp(_Web, "defaultDocumentLibrary", List, "DefaultDocumentLibrary");
addProp(_Web, "customListTemplates", SharePointQueryableCollection, "getcustomlisttemplates");
_Web.prototype.getList = function (listRelativeUrl) {
    return List(this, `getList('${escapeQueryStrValue(listRelativeUrl)}')`);
};
_Web.prototype.getCatalog = function (type) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield this.clone(Web, `getcatalog(${type})`).select("Id").get();
        return List(odataUrlFrom(data));
    });
};
//# sourceMappingURL=web.js.map